import * as React from 'react';
import { useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { TableVirtuoso, TableComponents } from 'react-virtuoso';
import { Box, Button, Grid, Modal, Typography } from '@mui/material';
import { LocalImage } from 'Utils/images';
import { EditProductInventory } from './EditProductInventory';
import CloseIcon from '@mui/icons-material/Close';
import { InFlow } from 'Features/services/inFlow.api';

interface Data {
  id: number;
  amount: number;
  totalQuantityOnHand: number,
  sku: string;
  pname: string;
}

interface ColumnData {
  dataKey: keyof Data;
  label: string;
  numeric?: boolean;
  width: string;
}

const columns: ColumnData[] = [
  {
    width: "20%",
    label: 'QTY',
    dataKey: 'totalQuantityOnHand',
  },
  {
    width: "25%",
    label: 'SKU #',
    dataKey: 'sku',
    numeric: true,
  },
  {
    width: "55%",
    label: 'Product Name',
    dataKey: 'pname',
    numeric: true,
  },
];

const VirtuosoTableComponents: TableComponents<Data> = {
  Scroller: React.forwardRef<HTMLDivElement>((props, ref) => (
    <TableContainer component={Paper} {...props} ref={ref} />
  )),
  Table: (props: any) => (
    <Table {...props} sx={{ borderCollapse: 'separate', tableLayout: 'fixed', borderRadius: 0 }} />
  ),
  TableHead,
  TableRow: ({ item: _item, ...props }: any) => <TableRow {...props} />,
  TableBody: React.forwardRef<HTMLTableSectionElement>((props, ref) => (
    <TableBody {...props} ref={ref} />
  )),
};

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: '12px',
  width: '50%',
  height: '90%',
  overflowX: "hidden",
  overflowY: "scroll",
};

export default function LowProducts() {


  const [lowProducts, setLowProducts] = useState<Data[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0)

  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const fetchLowProducts = async () => {
    try {

      const response = await InFlow.instance.lowProducts(0);
      const data = response.data?.productsList;
      setTotalCount(response.data?.count)

      if (data) {
        const filteredData = data.map((product: any, index: number) => ({
          id: index,
          totalQuantityOnHand: parseFloat(product.totalQuantityOnHand).toFixed(1),
          // amount: parseFloat(product.unitPrice).toFixed(2),
          sku: product.sku,
          pname: product.name,
        }));
        setLowProducts(filteredData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchLowProducts();
  }, []);

  function fixedHeaderContent() {

    return (
      <TableRow>
        {columns.map((column) => (
          <TableCell
            key={column.dataKey}
            variant="head"
            align={column.numeric || false ? 'right' : 'left'}
            style={{ width: column.width }}
            sx={{
              backgroundColor: '#FFAF604E', fontSize: 10, textAlign: "center", borderTop: "3px solid #FFC181", borderRadius: 0, p: 0.5
            }}
          >
            {column.label}
          </TableCell>
        ))}
      </TableRow>
    );
  }

  function rowContent(_index: number, row: Data) {
    return (
      <React.Fragment>
        {columns.map((column) => (
          <TableCell
            sx={{ fontSize: 10, textAlign: "center", border: "none", borderBottom: "1px solid #f1f1f1", p: 0.5 }}
            key={column.dataKey}
            align={column.numeric || false ? 'right' : 'left'}
          >
            {row[column.dataKey]}
            
          </TableCell>
        ))}
      </React.Fragment>
    );
  }

  return (
    <Box className="product-list-style01">
      <Box sx={{ pr: 1 }}>
        <Grid container>
          <Grid sm={9} md={10} sx={{ pl: 1, pb: 1 }}>
            <Typography sx={{ fontSize: "13px", p: 0 }}>
              Low Products
            </Typography>
            <Typography sx={{ color: "#FF7F00", fontSize: "21px", fontWeight: "bold", p: 0 }}>
              {totalCount}
            </Typography>
          </Grid>

          {/* <Grid sm={3} md={2} sx={{ textAlign: "right", pr: 1 }}>
            <Box className="arrow-style-01" width={55} sx={{ cursor: "pointer" }}>
              <Box className="arrow-style-02" onClick={handleOpen}>
                <img style={{ width: "60%" }} className="arrow-style-03" alt="WG Fabricators logo" src={LocalImage.iconLinearExport} />
              </Box>
            </Box>
          </Grid> */}


        </Grid>
      </Box>
      <Box className="product-list-table">
        {lowProducts?.length > 0 ? (
          <TableVirtuoso
            data={lowProducts}
            components={VirtuosoTableComponents}
            fixedHeaderContent={fixedHeaderContent}
            itemContent={rowContent}
          />
        ) : (
          <Typography>No low products available.</Typography>
        )}
      </Box>

      {/* <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <>
          <Box sx={style} className="modal-scroll-content">
            <EditProductInventory closeModal={handleClose} />
          </Box>
          <Button
            sx={{ backgroundColor: '#FFAA2A', padding: '8px 0px', float: 'right', right: '19%', top: '2.5%' }}
            onClick={handleClose}>
            <CloseIcon sx={{ fontSize: '32px', color: '#fff' }} />
          </Button>
        </>
      </Modal> */}

      
      
    </Box>
  );
}
